var _path, _path2, _ellipse, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 222,
    viewBox: "0 0 222 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0485 54.2367C68.9276 30.5782 110.483 29.1768 147.865 51.1067C185.247 73.0366 204.3 109.993 190.421 133.652C176.542 157.31 134.986 158.712 97.6043 136.782C60.2223 114.852 41.1694 77.8952 55.0485 54.2367Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.749 68.2292C173.131 90.1591 192.183 127.116 178.304 150.774L190.422 133.653C204.301 109.994 185.249 73.0376 147.867 51.1077C110.485 29.1778 68.9293 30.5791 55.0502 54.2376L46.0879 66.9005C44.918 68.2865 43.8629 69.7728 42.9322 71.3592L46.0879 66.9005C62.3654 47.6176 100.873 47.7698 135.749 68.2292Z",
    fill: "url(#paint0_linear_1339_22706)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.616,
    cy: 111.068,
    rx: 78.4735,
    ry: 49.6647,
    transform: "rotate(-149.602 110.616 111.068)",
    fill: "url(#paint1_linear_1339_22706)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4819 153.903C122.864 175.832 164.419 174.431 178.298 150.773L187.261 138.11C188.431 136.724 189.486 135.238 190.416 133.651L187.261 138.11C170.983 157.393 132.475 157.24 97.5999 136.781L97.6 136.781C60.218 114.851 41.1652 77.8944 55.0442 54.2359L42.9263 71.3575C29.0472 95.016 48.1001 131.973 85.4821 153.903L85.4819 153.903Z",
    fill: "#7551FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.301 150.775C164.422 174.434 122.866 175.835 85.4844 153.905L85.4845 153.905C48.1025 131.975 29.0497 95.0185 42.9288 71.36L55.0466 54.2386C68.9257 30.5801 110.481 29.1788 147.863 51.1087C185.245 73.0385 204.298 109.995 190.419 133.654C189.488 135.24 188.433 136.727 187.263 138.113L178.301 150.775Z",
    fill: "#7551FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.29
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9287 80.6213C68.0199 61.7997 101.175 60.6536 130.982 78.0615C160.79 95.4694 175.962 124.839 164.871 143.661C153.78 162.482 120.625 163.628 90.8174 146.221C61.01 128.813 45.8375 99.4429 56.9287 80.6213Z",
    fill: "#7551FF",
    fillOpacity: 0.77
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1339_22706",
    x1: 195.294,
    y1: 111.886,
    x2: 103.226,
    y2: 31.1097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1339_22706",
    x1: 32.1426,
    y1: 111.068,
    x2: 189.09,
    y2: 111.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6B0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BA9AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin2);
export default __webpack_public_path__ + "static/media/Coin2.94abb061878f2efc4c42ec60926d318c.svg";
export { ForwardRef as ReactComponent };